<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="Page_11"><span>1</span></p>
<p class="ct1" id="d7e82011"><span><a href="#/Lind_9781595554796_epub_c4_r1#d6e2" id="d7e2"><span class="small">Part 1</span><br/><br/> <i>The Idea and the Legacy </i></a></span></p>
<p class="epigraph" id="d7e82811"><span><i>Laughter is one of the most frequent symptoms of madness.</i></span></p>
<p class="extbd" id="d7e83311"><span>—C<span class="small">HARLES </span>B<span class="small">AUDELAIRE </span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lind_9781595554796_epub_c6_r1.vue?e7304d66